import { LimitedAccountPopup } from "Components/Dashboard/LimitedAccountPopup";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { SimpleMobileLayout } from "Components/Layout/SimpleMobileLayout";
import { MerchantPaymentInitiator } from "Components/Merchant/Initiate/MerchantPaymentInitiator";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useIsMobile } from "Hooks/useIsMobile";
import { useSearchParams } from "Navigation/useSearchParams";
import { Resources, useResource } from "Translations/Resources";

export const MerchantInitiateKeypadPaymentPage = () => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();
  const isMobile = useIsMobile();

  const bankAccountPublicID = searchParams.get("publicID") ?? undefined;
  const title = t(Resources.Pages.Titles.NewPayment);

  if (isMobile) {
    return (
      <SimpleMobileLayout title={title}>
        <StyledPageWrapper>
          <MerchantPaymentInitiator
            variant="keypad"
            bankAccountPublicID={bankAccountPublicID}
          />
          <LimitedAccountPopup />
        </StyledPageWrapper>
      </SimpleMobileLayout>
    );
  }

  return (
    <AuthenticatedLayout
      title={title}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: null,
      }}
    >
      <StyledPageWrapper>
        <MerchantPaymentInitiator
          variant="keypad"
          bankAccountPublicID={bankAccountPublicID}
        />
        <LimitedAccountPopup />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default MerchantInitiateKeypadPaymentPage;
